<template>
<div class="chapter">
<div class="inner_page">
<p class="prect"><a id="pIX"></a>ILLUSTRATIONS</p>
<p class="ahd">Plates</p>
<p class="nl-f"><a href="#/plates.htm#plate1"><span class="numblock">1.</span></a>Bronze gilt cuirass from Ksour es-Saf, Tunisia, <i>c</i>. third century <span class="fsc">BCE</span>. © Tunis, Musée National du Bardo.</p>
<p class="nl"><a href="#/plates.htm#plate2"><span class="numblock">2.</span></a>View from Eryx towards Drepanum (Trapani) and the Aegates Islands. Author’s photograph.</p>
<p class="nl"><a href="#/plates.htm#plate3"><span class="numblock">3.</span></a><i>The Oath of Hannibal</i> by Benjamin West, 1770. Royal Collection Trust © Her Majesty Queen Elizabeth II 2014.</p>
<p class="nl"><a href="#/plates.htm#plate4"><span class="numblock">4.</span></a><i>The Oath of Hannibal</i>, eighteenth-century cartoon. Courtesy of the Trustees of the British Museum.</p>
<p class="nl"><a href="#/plates.htm#plate5"><span class="numblock">5.</span></a>Punic di-shekel showing Melqart (possibly Hamilcar) with club on obverse and an elephant and rider on reverse, dated <i>c</i>. 237–209 <span class="fsc">BCE</span>. Courtesy of the Trustees of the British Museum.</p>
<p class="nl"><a href="#/plates.htm#plate6"><span class="numblock">6.</span></a><i>Hannibal Crossing the Alps</i> by Heinrich Leutemann, 1866, etching, hand coloured. Held in the public domain at Yale University Art Gallery.</p>
<p class="nl"><a href="#/plates.htm#plate7"><span class="numblock">7.</span></a><i>Hannibal with the head of Hasdrubal</i>, Giambattista Tiepolo, 1725–1730. © Kunsthistorisches Museum, Vienna.</p>
<p class="nl"><a href="#/plates.htm#plate8"><span class="numblock">8.</span></a>Hannibal’s monument in Turkey, commissioned by Atatürk. Author’s photograph.</p>
<p class="nl-l"><a href="#/plates.htm#plate9"><span class="numblock">9.</span></a>Bust of Hannibal (?) from Capua. Courtesy of the Mary Evans Picture Library.</p>
<p class="ahd"><a id="pX"></a>Maps</p>
<p class="nl-f"><a href="#/maps.htm#map1"><span class="numblock">1.</span></a>The central Mediterranean: Carthage, Rome and Sicily</p>
<p class="nl"><a href="#/maps.htm#map2"><span class="numblock">2.</span></a>The western Mediterranean</p>
<p class="nl-l"><a href="#/maps.htm#map3"><span class="numblock">3.</span></a>Carthage and environs</p>
<p class="nl">All maps drawn by Stephen Copp.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// list_of_illustrations.vue?72dc55e8